module.exports = __webpack_public_path__ + "37cd3797f9f15ade3bb895b94f8df32a.fbx";